import React from "react";
import { t } from "ttag";
import { Button, Row, SearchIcon, Spinner, TextField, Typography } from "@coolremote/shared";
import styles from "./ModbusSiteLibraryManagementDialog.module.css";

/** Shared width for the toolbar's actions, so swapping between modes doesn't shift the layout. */
const BUTTON_WIDTH = 110;
const EXPORT_SELECTED_WIDTH = 170;

interface IProps {
  search: string;
  onSearchChange: (value: string) => void;
  exportMode: boolean;
  selectedCount: number;
  onEnterExportMode: () => void;
  onExitExportMode: () => void;
  onExportSelected: () => void;
  siteId?: string;
  importing: boolean;
  importProgress: { done: number; total: number } | null;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const LibraryToolbar: React.FC<IProps> = ({
  search,
  onSearchChange,
  exportMode,
  selectedCount,
  onEnterExportMode,
  onExitExportMode,
  onExportSelected,
  siteId,
  importing,
  importProgress,
  fileInputRef,
  onFileChange,
}) => (
  <div className={styles.searchWrap}>
    <div className={styles.searchField}>
      <TextField fullWidth startIcon={<SearchIcon width={16} height={16} />} placeholder={t`Search by name`} value={search} onChange={onSearchChange} />
    </div>
    <Row gap={8} align="center">
      {exportMode ? (
        <>
          <Button white size="medium" width={BUTTON_WIDTH} onClick={onExitExportMode}>
            {t`Cancel`}
          </Button>
          {/* Fixed width so the label growing with the selected count doesn't resize the button. */}
          <Button size="medium" width={EXPORT_SELECTED_WIDTH} disabled={selectedCount === 0} onClick={onExportSelected}>
            {t`Export Selected` + ` (${selectedCount})`}
          </Button>
        </>
      ) : (
        <>
          {siteId && (
            importing ? (
              <div className={styles.importProgress}>
                <Spinner size={14} />
                <Typography variant="meta">
                  {t`Importing`} {importProgress?.done} / {importProgress?.total}…
                </Typography>
              </div>
            ) : (
              <>
                <Button white size="medium" width={BUTTON_WIDTH} onClick={() => fileInputRef.current?.click()}>
                  {t`Import`}
                </Button>
                <input ref={fileInputRef} type="file" accept=".json,application/json" style={{ display: "none" }} onChange={onFileChange} />
              </>
            )
          )}
          <Button white size="medium" width={BUTTON_WIDTH} onClick={onEnterExportMode}>
            {t`Export`}
          </Button>
        </>
      )}
    </Row>
  </div>
);

export default LibraryToolbar;
